/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */

import React from 'react';

export const svgApple = (
  <svg
    className="social__button--icon"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.22443 2.66238C8.71626 3.29487 7.86293 3.76924 7.18217 3.76924C7.10547 3.76924 7.02876 3.75935 6.98082 3.74947C6.97124 3.70994 6.95206 3.59135 6.95206 3.47276C6.95206 2.66238 7.34517 1.87176 7.77663 1.36775C8.32315 0.705606 9.23402 0.211472 9.99148 0.181824C10.0107 0.270768 10.0202 0.379477 10.0202 0.488187C10.0202 1.28868 9.68466 2.08918 9.22443 2.66238ZM5.88999 15.4327C5.54831 15.5839 5.2245 15.7273 4.78516 15.7273C3.84553 15.7273 3.19354 14.8378 2.44567 13.7507C1.57315 12.466 0.863636 10.4796 0.863636 8.60186C0.863636 5.57776 2.77166 3.97677 4.65092 3.97677C5.19943 3.97677 5.70061 4.18407 6.14625 4.3684C6.50298 4.51596 6.82412 4.64879 7.10547 4.64879C7.3495 4.64879 7.65362 4.52492 8.00808 4.38054C8.50316 4.17889 9.09644 3.93724 9.76136 3.93724C10.1832 3.93724 11.7269 3.97677 12.7433 5.47894C12.7374 5.48361 12.725 5.49206 12.7069 5.50438C12.4568 5.67454 11.1229 6.58221 11.1229 8.44374C11.1229 10.7464 13.0692 11.5667 13.1364 11.5864C13.1346 11.5909 13.1307 11.6035 13.1244 11.6237C13.0604 11.8278 12.7553 12.8008 12.1009 13.7903C11.4585 14.739 10.7777 15.7075 9.76136 15.7075C9.26044 15.7075 8.94125 15.5618 8.61169 15.4114C8.25999 15.2508 7.89647 15.0849 7.28764 15.0849C6.67554 15.0849 6.27161 15.2637 5.88999 15.4327Z"
      fill="#333333"
    />
  </svg>
);

export const svgGoogle = (
  <svg
    className="social__button--icon"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.68 8.18183C15.68 7.61456 15.6291 7.06911 15.5345 6.54547H8V9.64002H12.3055C12.12 10.64 11.5564 11.4873 10.7091 12.0546V14.0618H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18183Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C10.16 16 11.9709 15.2836 13.2945 14.0618L10.7091 12.0545C9.99273 12.5345 9.07637 12.8181 8 12.8181C5.91637 12.8181 4.15273 11.4109 3.52364 9.51996H0.85091V11.5927C2.16727 14.2072 4.87273 16 8 16Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52364 9.51995C3.36364 9.03995 3.27273 8.52723 3.27273 7.99995C3.27273 7.47268 3.36364 6.95995 3.52364 6.47995V4.40723H0.850909C0.309091 5.48723 0 6.70904 0 7.99995C0 9.29086 0.309091 10.5127 0.850909 11.5927L3.52364 9.51995Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.18182C9.17455 3.18182 10.2291 3.58545 11.0582 4.37818L13.3527 2.08364C11.9673 0.792727 10.1564 0 8 0C4.87273 0 2.16727 1.79273 0.85091 4.40727L3.52364 6.48C4.15273 4.58909 5.91637 3.18182 8 3.18182Z"
      fill="#EA4335"
    />
  </svg>
);
